// Curated axe-core run options for scanning a CMS rich-text fragment.
// Page-level rules are disabled because a content fragment is not a full page.
export const AXE_RUN_OPTIONS = {
  runOnly: {
    type: 'tag' as const,
    values: ['wcag2a', 'wcag2aa', 'wcag21a', 'wcag21aa', 'wcag22aa'],
  },
  rules: {
    region: {enabled: false},
    'landmark-one-main': {enabled: false},
    'page-has-heading-one': {enabled: false},
    bypass: {enabled: false},
    'html-has-lang': {enabled: false},
    'html-lang-valid': {enabled: false},
    'document-title': {enabled: false},
    'meta-viewport': {enabled: false},
    'landmark-unique': {enabled: false},
  } as Record<string, {enabled: boolean}>,
  resultTypes: ['violations' as const],
}
